export const actionTypes = {
	FLOORS_SET_LIST: 'FLOORS_SET_LIST',
	FLOORS_RESET: 'FLOORS_RESET',
};

export function setFloorsList(data) {
	return {
		type: actionTypes.FLOORS_SET_LIST,
		payload: {
			data,
		},
	};
}

export function resetFloors() {
	return {
		type: actionTypes.FLOORS_RESET,
	};
}

const initialState = {
	list: [],
};

export default function floors(state = initialState, action) {
	switch (action.type) {
		case actionTypes.FLOORS_SET_LIST:
			return {
				...state,
				list: action.payload.data,
			};
		case actionTypes.FLOORS_RESET:
			return initialState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/model/floors.js